import React, { Component } from "react";
import { Container } from "@material-ui/core";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as flightDetailsActiona from "../actions/flightDetails";
import * as stationAction from "../actions/stationNames";
import { HubConnectionBuilder, LogLevel } from "@aspnet/signalr";
import "../style/main.scss";
import PropTypes from "prop-types";
import { Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import FlightDetails from "../containers/flightDetails";
import ParentModal from "../components/modal/parent";
import * as modalTypes from "../components/modal/modalTypes";
import * as timexHelper from "../common/helper";
import LocalStorageHelper from "../common/localStorageHelper";
import ErrorBoundary from "../common/errorBoundary";
import User from "../components/user";
import * as config from "../data/config";
import AuthenticationApi from "../api/authenticationApi";
import * as testData from "../data/testData";
import StationName from "./stationNames";
import "../components/flightDetail/flightDetail.global.scss";
import FilterListIcon from "@material-ui/icons/FilterList";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import { Loading } from "../components/flightDetail/loading";
import { render } from "react-dom";
import { ReactComponent as Logo } from "../assets/images/ftp_loader.svg";
import CircularProgress from "@material-ui/core/CircularProgress";
import AllStations from "../components/stationNames/allStations";
import SearchBar from "../components/flightDetail/searchBar";

class FlightSchedule extends Component {
    moment = require("moment");

    constructor(props) {
        super(props);
        // console.info("flightscedule constructor props", props);
        this.toggleDropDown_Stn = this.toggleDropDown_Stn.bind(this);
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.handleFlightFilters = this.handleFlightFilters.bind(this);
        // console.info("11 props stations", props);
        // console.info("11 props flightscedule", props.allStations);
        this.stationCode = props.stationCode;

        // console.info("this.stationCode ff", props.stationCode);

        this.state = {
            dropdownOpen: false,
            stationCode: this.props.stationCode,
            modalType: "",
            isModalOpen: false,
            connectionID: "",
            groupName: "",
            selectedFlightInfo: "",
            isAuthenticated: false,
            isLoading: true,
            user: null,
        };
        let stationCode = this.props.stationCode;
        // console.info("flightScedule station code from stationclass", stationCode);
    }

    /* #region  PropTypes */
    static propTypes = {
        handleFlightFilters: PropTypes.func,
    };
    /* #endregion */

    /* #region Flight filter event handlers */
    toggleDropDown_Stn() {
        this.setState((prevState) => ({
            dropdownOpen: !prevState.dropdownOpen,
        }));
    }

    handleRefresh(resolve, reject) {
        window.location.reload(true);
    }

    handleFlightFilters(filters, event) {
        let newData = {};
        // console.info(" this.props.flightDetails", this.props.flightDetails);
        newData.flightDetails = this.props.flightDetails;
        // console.info(" flightScedule.js newData.flightDetails", newData.flightDetails);
        this.props.actions.setFlightDetails(newData, filters);
    }

    handleStateChange(isAuthenticated, user) {
        this.setState({ isAuthenticated: isAuthenticated, user: user });
    }

    /* #endregion */

    /* #region  Modal event handlers */
    showModal = (type, flightDetail) => {
        this.setState({ modalType: type, isModalOpen: true, selectedFlightInfo: flightDetail });
        // console.info("flightDetail", flightDetail);
    };

    hideModal = () => {
        this.setState({ isModalOpen: false });
    };
    /* #endregion */

    reloadOnTimeout() {
        var moment = require("moment");
        let threshold = config.environment.settings.reloadOnTimeout;

        if (threshold > 0) {
            let forceReload = moment().diff(this.props.lastUpdate, "seconds") > threshold;

            if (forceReload) {
                window.location.reload(true);
            }
        }
    }

    removeConnection() {
        const connectionId = localStorage.getItem("ConnectionId");
        if (!connectionId) return;

        let api = config.environment.api;
        let url = api.baseURL + api.removeConnection + "/" + connectionId;

        let user = LocalStorageHelper.getUser();
        let token = "";
        if (user && user.token) token = user.token;

        this.state.hubConnection.closedCallbacks = [];
        this.state.hubConnection.stop();

        fetch(url, {
            method: "DELETE",
            headers: {
                Authorization: token,
            },
        })
            .then((response) => {
                if (!response.ok) {
                    console.log("Removing connection was not successful.");
                } else {
                    console.log("Connection removed successfully.");
                }
            })
            .catch((error) => {
                console.error("Removing connection was not successful.", error);
            });
    }

    componentDidMount() {
        let api = config.environment.api;
        let url = api.baseURL + api.signalRHubURL;

        console.info("signalR url", url);
        /* #region oAuth  */

        const user = LocalStorageHelper.getUser();
        const isAuthenticated = timexHelper.IsLoggedIn() && user;
        if (config.environment.ignoreAuthentication) {
            this.setState({ isAuthenticated: true, isLoading: false, user: null });
        } else if (isAuthenticated) {
            AuthenticationApi.validateToken(user.token).then((isValid) => {
                if (isValid) {
                    this.setState({ isAuthenticated: true, user: user });
                    //calling action or API from here
                    const hh = this.props.actions.getAllStations();
                    const demo = this.props.allStations;
                    //console.info("flightscedule compnentmount allStations", hh);
                } else {
                    LocalStorageHelper.removeUser();
                }
                this.setState({ isLoading: false });
            });
        } else {
            this.setState({ isLoading: false });
        }
        /* #endregion oAuth */

        /* #region SignalR  */
        const hubConnection = new HubConnectionBuilder().withUrl(url).configureLogging(LogLevel.Information).build();

        this.setState({ hubConnection }, () => {
            this.state.hubConnection
                .start(function (a, b, c) {})
                .then(() => console.log("Connection started!"))
                .catch((err) => console.log("Error while establishing connection :("));

            this.state.hubConnection.on('SendAsync', (payload) => {               
                this.props.actions.dataReceived()                
                let newData = {}
                console.info("SendAsync payload flightscedule", this.state.connectionID, payload);
                newData.flightDetails = payload  

                console.info("newData.flightDetails", newData);
                console.info("newData.flightDetails", this.props.flightFilters);

                if (this.state.selectedFlightInfo) {
                    // display selected flight num outbound
                    console.info("Flight Scedule 7777", this.state.selectedFlightInfo);
                    var newSelectedFlightInfo = newData.flightDetails.filter(
                        (fd) => fd.LegHashKeyOutbound == this.state.selectedFlightInfo.LegHashKeyOutbound
                    );
                    if (newSelectedFlightInfo.length > 0) {
                        this.setState({
                            selectedFlightInfo: newSelectedFlightInfo[0],
                        });
                    }
                }

                const storedStation = JSON.parse(localStorage.getItem("selectedStation"));
                var flightFilters =
                    LocalStorageHelper.appliedFilters.get() ?? timexHelper.GetDefaultFlightFilters(storedStation);

                this.props.actions.setFlightDetails(newData, flightFilters);
                console.log("Flight details updated");
            });

            this.state.hubConnection.on("SendConnectionInfoAsync", (connectionID, groupName) => {
                var selectedStationCode = this.stationCode;
                this.setState({
                    connectionID: connectionID,
                    groupName: groupName,
                });
                console.log("Websocket connection info updated");
                console.log("connectionID", connectionID);
                console.log("connectionID groupName", groupName);

                localStorage.setItem("ConnectionId", connectionID);

                var selectedStationCode = this.stationCode;

                const requestOptions = { method: "POST" };

                let api = config.environment.api;
                let url = api.baseURL + api.sendClientConnectionIDURL;
                console.info("send client id url", url);

                fetch(url + connectionID + "&station=" + selectedStationCode, requestOptions);
            });

            this.state.hubConnection.onclose(function () {
                setTimeout(function () {
                    hubConnection
                        .start()
                        .then(() => console.log("Connection RE-started!"))
                        .catch((err) => console.log("Error while establishing connection :("));
                }, 5000); // Restart connection after 5 seconds.
            });
        });
        /* #endregion SignalR*/

        // Reload data on timeout
        //     this.setState({
        //         timerId: setInterval(() =>{
        //    let stationList =  JSON.parse(localStorage.getItem('stationKey'))
        //                    console.info("uuoo flightscedule", stationList)

        //                   // if(flightFilters == null)
        //                    //{
        //                     var defaultFilter =  { gateFilters: timexHelper.GetGates('YTZ'), hourFilter: [0, 2],
        //                     flightNumbersFilter: [1, 2] };

        //                    if(localStorage.getItem("appliedFilters") && JSON.parse(localStorage.getItem("appliedFilters")))
        //                    //&& JSON.parse(localStorage.getItem("appliedFilters")).length > 0
        //                    {
        //                         var flightObject = JSON.parse(localStorage.getItem("appliedFilters")).currentFilter;
        //                         if(flightObject)
        //                         {
        //                             defaultFilter = flightObject;
        //                         }
        //                    }
        //                    //this.props.actions.setFlightDetails(stationList, defaultFilter)
        //                    this.props.actions.getFlightDetails(stationList, defaultFilter)

        //                    //}
        //                    //else
        //                    //{
        //                 //     this.props.actions.setFlightDetails(stationList, { gateFilters: timexHelper.GetGates('YTZ'), hourFilter: [0, 2],
        //                 //    flightNumbersFilter: [1, 2] })
        //                    //}

        //         },
        //          20000)
        //         })
    }

    componentWillUnmount() {
        if (this.state.hubConnection) {
            this.removeConnection();
        }
    }

    render() {
        let { flightDetails, isFetched } = this.props;

        var flightFilters =
            JSON.parse(localStorage.getItem("appliedFilters"))?.currentFilter ?? timexHelper.GetDefaultFlightFilters();

        // console.info("loader value", isFetched);
        let Render = "hide";
        function checkFlightDetails() {
            if (isFetched) {
                return <Loading />;
            } else {
                Render = "show";
                return "";
            }
        }

        return (
            <ErrorBoundary>
                {checkFlightDetails()}
                {/* component here if FlightDetails == null then show loading, if filteredFlightDetails then show a message*/}
                <Container maxWidth="sm" className={Render}>
                    <div className="floatLeft logo">
                        <Logo />{" "}
                    </div>
                    <a
                        className="filter floatRight"
                        onClick={() => {
                            this.showModal(modalTypes.STATION_FILTER);
                        }}
                        // handleClose={this.hideModal}
                    >
                        <FilterListIcon /> Filter <KeyboardArrowRightIcon />
                    </a>

                    <div className="clear"></div>
                    <SearchBar
                        flightDetails={this.props.flightDetails}
                        setFlightDetails={this.props.actions.setFlightDetails}
                        flightFilters={flightFilters}
                    ></SearchBar>
                    <div>
                        <FlightDetails onShowModal={this.showModal} />
                    </div>
                    <ParentModal
                        selectedFlightInfo={this.state.selectedFlightInfo}
                        handleClose={this.hideModal}
                        show={this.state.isModalOpen}
                        modalType={this.state.modalType}
                        flightFilters={flightFilters}
                        allFlights={this.props.allFlights}
                        allFlightsData={this.props.allFlightsData}
                        onFlightFilter={this.handleFlightFilters}
                        allStations={this.props.allStations}
                        allModels={this.props.allModels}
                        allGatess={this.props.allGatess}
                        allGatess11={this.props.allGatess11}
                    />
                </Container>
                {/* </ReactPullToRefresh> */}
                {/* {user()} */}
                {flightDetails.length >= 1 ? (
                    <User {...this.state} onLoginChange={this.handleStateChange.bind(this)} />
                ) : null}
            </ErrorBoundary>
        );
    }
}

const mapStateToProps = (state) => {   
    const { flightDetails, flightFilters, lastUpdate, allFlights, allFlightsData, isFetched, allModels, allGatess, allGatess11, refreshedTime } = state.flightDetail
    const { allStations } = state.StationDetail
    //console.log("flightscedule stations component", state.StationDetail)
    return {
        flightDetails,
        flightFilters,
        lastUpdate,
        allFlights,
        allFlightsData,
        allStations,
        allModels,
        allGatess,
        allGatess11,
        isFetched,
        refreshedTime,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, flightDetailsActiona, stationAction), dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(FlightSchedule);
